import React, {useRef, useEffect, useState} from 'react'
import useWindowSize from 'src/shared/service/use_window_size.jsx'
import {Hotspot} from "./hotspot";
import {useDispatch, useSelector} from "react-redux";
import useScrollbarVisibility from 'src/shared/service/use_scrollbar_visibility'
import {orderBy} from "lodash";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import VirtualCongressBackground from './virtual_congress_background'
import useInterval from '@use-it/interval'
import classNames from 'classnames'
import {setBackgroundVideoLoopState} from "../exhibition_actions";

export default function VideoLooper(
  {
    videoUrl,
    introStart,
    introEnd,
    loopStart,
    loopEnd,
    outroStart,
    outroEnd,
  }) {
  const dispatch = useDispatch()
  const isBoothEditor = useSelector(state => state.isBoothEditor)
  const video = useRef(null)
  const videoSource = useRef(null)
  const [currentVideoUrl, setCurrentVideoUrl] = useState(videoUrl)

  // All states
  // intro: Indicates that the videoUrl has been set and the intro should play
  // loop: Indicates that the intro phase has finished and the loop should play.
  // outro: Indicates that the videoUrl has changed and outro should be played.
  // outro_finished: Indicates that the outro is fully finished.
  const videoState = useSelector(state => state.backgroundVideoLoop?.state) || "intro"

  useEffect(() => {
    // if (videoUrl != currentVideoUrl) {
    //   dispatch(setBackgroundVideoLoopState("outro"))
    // }

    if (video.current && videoSource.current && currentVideoUrl) {
      if (videoSource.current.getAttribute('src') != currentVideoUrl) {
        videoSource.current.setAttribute('src', currentVideoUrl)
        video.current.play()
      }

      if (videoState === "outro") {
        video.current.removeAttribute("loop")
        video.current.currentTime = outroStart
        video.current.play()
      }

      video.current.onended = (event) => {
        if (videoState === "outro") {
          dispatch(setBackgroundVideoLoopState("outro_finished"))
        }
      }

      video.current.ontimeupdate = (event) => {
        switch (videoState) {
          case "intro":
            if (video.current.currentTime >= introEnd) {
              dispatch(setBackgroundVideoLoopState("loop"))
              if (loopStart <= loopEnd) {
                video.current.pause()
                video.current.currentTime = loopStart
              }
            }
            break;
          case "loop":
            if (loopStart > loopEnd && video.current.currentTime >= loopEnd) {
              video.current.currentTime = loopStart
            }
            break;
          case "outro":
            if (outroEnd && video.current.currentTime >= outroEnd) {
              dispatch(setBackgroundVideoLoopState("outro_finished"))
              video.current.pause()
              video.current.currentTime = outroEnd
            }
            break;
        }
      };
    }

    return () => {
      if (video.current) {
        video.current.ontimeupdate = null
        video.current.onended = null
      }
    }
  }, [
    video.current,
    videoSource.current,
    currentVideoUrl,
    setCurrentVideoUrl,
    videoState,
    videoUrl,
    introStart,
    introEnd,
    loopStart,
    loopEnd,
    outroStart,
    outroEnd,
  ])

  let hotspotStyle = ""
  if (!isBoothEditor && (videoState == "intro" || videoState == "outro")) {
    hotspotStyle = `
      .hotspot-desktop {
        display: none;
      }
      .image-map-hover-image {
        display: none;
      }
    `
  }

  return <>
    <style>
      {`
      ${hotspotStyle}
      *::-webkit-media-controls-panel {
        display: none!important;
        -webkit-appearance: none;
      }
      /* Old shadow dom */

      *::--webkit-media-controls-play-button {
        display: none!important;
        -webkit-appearance: none;
      }
      /* New shadow dom */

      *::-webkit-media-controls-start-playback-button {
        display: none!important;
        -webkit-appearance: none
      }
    `}
    </style>
    <video ref={video} style={{width: "100%", position: "absolute"}} loop autoPlay muted>
      <source ref={videoSource} type="video/mp4"/>
    </video>
  </>
}
